import { useContext, useMemo } from "react";
import { selectFilter, selectPagination, selectSort, } from "../../../store/filesDiffSlice";
import { ReportContext } from "../../context";
import { useReportSelector } from "../../hooks";
import { useGetFilesDiffQuery, useGetSingleFileDiffQuery, } from "../../services/diff.api";
export const useGetFilesDiff = () => {
    var _a;
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { diffId } = useContext(ReportContext);
    const multiple = useGetFilesDiffQuery({ filter, pagination, sort, ui_id: diffId }, {
        skip: Boolean(filter.ui_file_id),
    });
    const single = useGetSingleFileDiffQuery({
        ui_item_id: (_a = filter.ui_file_id) !== null && _a !== void 0 ? _a : "",
        ui_id: diffId,
    }, {
        skip: !filter.ui_file_id,
    });
    const singleResponse = useMemo(() => ({
        ...single,
        data: single.data
            ? {
                files: [single.data],
                match_count: 1,
                next_page: "",
                previous_page: "",
            }
            : undefined,
    }), [single]);
    if (filter.ui_file_id) {
        return singleResponse;
    }
    else {
        return multiple;
    }
};
//# sourceMappingURL=useGetFilesDiff.js.map